import React from "react";

import { Container } from "./styles";

function Input({
  id,
  type,
  label,
  placeholder,
  maxLength,
  mensagemErro,
  value,
  handler,
  required,
  handlerKeyDown,
  tip,
  ...rest
}) {
  return (
    <Container>
      <label>{label}</label>
      <small>{tip}</small>
      <input
        {...rest}
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        maxLength={maxLength ? maxLength : ""}
        onChange={handler}
        onKeyDown={handlerKeyDown}
        required={required}
        style={mensagemErro ? { borderBottom: "1px solid red" } : {}}
      />
      <span>{mensagemErro}</span>
    </Container>
  );
}

export default Input;
